// src/lang/index.js
import Vue from "vue";
import VueI18n from "vue-i18n";
// 引入上面创建的语言包
import zh from "./zh-CN";
import en from "./en";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: "zh", // 设置当前默认语言
  fallbackLocale: "zh", // 当翻译缺失时，回退的语言
  messages: {
    // 注册语言包
    en,
    zh,
  },
});

export default i18n;
